/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRoleDTO } from './ProjectRoleDTO';
import {
    ProjectRoleDTOFromJSON,
    ProjectRoleDTOFromJSONTyped,
    ProjectRoleDTOToJSON,
} from './ProjectRoleDTO';

/**
 * 
 * @export
 * @interface ProjectMemberUpdateDTO
 */
export interface ProjectMemberUpdateDTO {
    /**
     * 
     * @type {ProjectRoleDTO}
     * @memberof ProjectMemberUpdateDTO
     */
    role: ProjectRoleDTO;
}



/**
 * Check if a given object implements the ProjectMemberUpdateDTO interface.
 */
export function instanceOfProjectMemberUpdateDTO(value: object): value is ProjectMemberUpdateDTO {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function ProjectMemberUpdateDTOFromJSON(json: any): ProjectMemberUpdateDTO {
    return ProjectMemberUpdateDTOFromJSONTyped(json, false);
}

export function ProjectMemberUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectMemberUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'role': ProjectRoleDTOFromJSON(json['role']),
    };
}

export function ProjectMemberUpdateDTOToJSON(value?: ProjectMemberUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': ProjectRoleDTOToJSON(value['role']),
    };
}

